export default "__VITE_ASSET__BoQqmRGC__"